import React from "react";
import { Box } from "@mui/material";
import ContainerWrapper from "./ContainerWrapper";
import CollectionRXCreate from "Components/Collection/CollectionRXCreate/CollectionRXCreate";
import CollectionMain from "Components/Collection/CollectionMain";
// const CollectionMain = React.lazy(() =>
//   import("Components/Collection/CollectionMain")
// );
// const CollectionRXCreate = React.lazy(() =>
//   import("Components/Collection/CollectionRXCreate/CollectionRXCreate")
// );

const Collection = ({ checkedChaseUp, setCheckedChaseUp }) => {
  const query = new URLSearchParams(window.location.search);

  return (
    <>
      {["createNewRx"].includes(query.get("actionType")) ? (
        <CollectionRXCreate />
      ) : (
        <CollectionMain
          checkedChaseUp={checkedChaseUp}
          setCheckedChaseUp={setCheckedChaseUp}
        />
      )}
    </>
  );
};

export default Collection;
